import React from "react";

import { useUrlParamSync } from "../hooks/useUrlParamSync";

export const UrlParamSyncHelper: React.FC = () => {
    useUrlParamSync();
    return null;
};
